module.exports = __webpack_public_path__ + "static/media/phone-volume.63a2225f.svg";